/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "Thai Silk",
    img: "img/product-1.png",
    price: 20,
    company: "GOOGLE",
    info:
      "Scarves, shirts, cushion covers, wallets and pillow covers are all hand-weaved using the smoothest threads of silk. It is laced out of caterpillars fed on a strict mulberry diet, woven with gradient textures and designs. Thai silk is one of the most exotic gifts and souvenirs in Thailand you can get for your family and friends, or yourself.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Thai spices",
    img: "img/product-2.png",
    price: 16,
    company: "SAMSUNG",
    info:
      "After going back home, if you miss the aroma of Thai curry or seafood, then Thai spices will take you right back to it. Crushed Chili, coriander seeds, nutmeg, cloves, cinnamon, star anise, prickly ash and long pepper are some commonly used spices available anywhere in the street market.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Thai Spa Products",
    img: "img/product-3.png",
    price: 8,
    company: "htc",
    info:
      "Thailand is known for spices, temples and relaxing massages at quiet places. The essential oils, scented candles and bubble baths that follow would sure be missed after you leave Thailand. But since you cannot bring Thailand home, you sure can bring along Thai soothing aromatic massages. They aren’t only calming, but also good for your skin. The spa products are one of the most sold souvenirs in Thailand. ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Soap Carvings",
    img: "img/product-4.png",
    price: 18,
    company: "htc",
    info:
      "If scented candles are standard gifts, then soap carvings can be the best replacement. They come in different shapes, sizes and styles from a structured blooming lotus to a dainty blue flower with a ladybug on it. Their fragrance is all the more exotic for a souvenir from Thailand.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "HTC Desire 626s",
    img: "img/product-5.png",
    price: 24,
    company: "htc",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Vintage Iphone",
    img: "img/product-6.png",
    price: 17,
    company: "apple",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Iphone 7",
    img: "img/product-7.png",
    price: 30,
    company: "apple",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Smashed Iphone",
    img: "img/product-8.png",
    price: 2,
    company: "apple",
    info:
      "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 10,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
